import { ActionTypes as action } from "./action-types";
import taskService from "../../../api/taskService";

const actions = {
    async createTask({ }, data) {
        const result = await taskService.createTask(data);
        return result;
    },
    async getTasksList({ commit, state }) {
        if (state.tasksList.length) {
            const tasksList = state.tasksList;
            commit(action.GET_TASKS_LIST, []);
            commit(action.GET_TASKS_LIST, tasksList);
        }
        const data = await taskService.getTasksList();
        commit(action.GET_TASKS_LIST, data.data);
    },
    async getTasksListWithoutCash({ commit }) {
        const data = await taskService.getTasksListWithoutCash();
        commit(action.GET_TASKS_LIST, data.data);
    },
    async getTask({ }, id) {
        const data = await taskService.getTaskById(id);
        return data.data;
    },
    async updateTask({ }, data) {
        const result = await taskService.updateTask(data);
        return result
    },
    async deleteTask({ }, id) {
        const data = await taskService.deleteTask(id);
        return data;
    },
    async setTasksFilter({ commit }, filter) {
        commit(action.SET_TASKS_FILTER, filter);
    },
    async setMyTasksFilter({ commit }, filter) {
        commit(action.SET_MY_TASKS_FILTER, filter);
    },
    async updateTaskStatus({ }, data) {
        const result = await taskService.updateTaskStatus(data);
        return result
    },
    async getTaskAssigneeDetails({ }, taskId) {
        const res = await taskService.getTaskAssigneeDetails(taskId);
        return res;
    },
    async saveTaskDocuments({ commit }, formData) {
        const result = await taskService.saveTaskDocuments(formData);
        return result
    },
    async downloadTaskDocument({ commit }, params) {
        const res = await taskService.downloadTaskDocument(params.documentId, params.filename);
        return res
    },
    async deleteTaskDocument({ }, id) {
        const data = await taskService.deleteTaskDocument(id);
        return data;
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
};

export default actions;
